import settings from '@/settings'

let listFaqs = (pagination, headers) => {
  return fetch(`${settings.apetrusApi}/faq/administrador/?page=${pagination.page}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let insertFaq = (data, headers) => {
  return fetch(`${settings.apetrusApi}/faq/inserir/`, {
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}

let deleteFaq = (id, headers) => {
  return fetch(`${settings.apetrusApi}/faq/deletar/?id_faq=${id}`, {
    method: 'DELETE',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let atualizarFaq = (id, data, headers) => {
  return fetch(`${settings.apetrusApi}/faq/atualizar/?id_faq=${id}`, {
    method: 'PUT',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}

export default {
  insertFaq,
  listFaqs,
  deleteFaq,
  atualizarFaq
}
